import * as React from 'react'

import {
  makeStyles,
  Text
} from '@fluentui/react-components'

import style from '../styles/error'

const useStyles = makeStyles(style)

const Error = (props) => {
  const { error } = props

  const classes = useStyles()

  return (
    <div className={classes.error}>
      <Text as='p' size={200}>{error}</Text>
    </div>
  )
}

export default Error
